import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  ReportDetailsPage,
  ReportTitle,
  ReportDate,
  ReportImage,
  ReportDescription,
  ReportContent,
  NavButtons,
  NavButton
} from '../Styles/StyledReportDetailsPage.js';
import r1 from '../Images/r1.webp'
import r2 from '../Images/r2.webp'
import r3 from '../Images/r3.webp'
import r4 from '../Images/r4.jpeg'
import r5 from '../Images/r5.jpeg'
import r6 from '../Images/r6.jpeg'
import r7 from '../Images/r7.jpeg'
import r8 from '../Images/r8.jpeg'
import r9 from '../Images/r9.jpeg'

const reports = [
  {
    id: 1,
    date: "10/8/24",
    title: "Q3 2024 MICHAEL REPORT",
    image:r1,
    description: "This is the description for the Q3 2024 report.",
    content: `
      This quarter has seen an exceptional performance in various sectors including technology and retail.
      The market trends have shifted significantly towards sustainability and green energy, which has propelled
      certain stocks to record highs. Consumer behavior is also changing, with more people opting for online
      shopping and fewer opting for traditional brick-and-mortar stores. This report outlines all the important
      figures, trends, and analysis from Q3 of 2024. We also provide a forecast for the upcoming quarter based on
      the ongoing shifts in the economic landscape. The growth potential in emerging markets is expected to continue
      with strong investment in infrastructure projects worldwide. 
      The outlook for the rest of the year is optimistic, although caution is advised with inflation concerns and supply chain disruptions.
    `
  },
  {
    id: 2,
    date: "7/7/24",
    title: "Mid-Year 2024 MICHAEL REPORT",
    image: r2,
    description: "This is the description for the Mid-Year 2024 report.",
    content: `
      Mid-Year 2024 has been a transformative period for industries worldwide. The economic recovery following the
      global recession has been slower than anticipated, but growth is still evident in key sectors like technology,
      healthcare, and manufacturing. This report highlights the economic indicators and detailed analysis for the
      first half of the year, including GDP growth rates, inflation trends, and employment figures. We have seen a
      gradual rebound in consumer spending, although concerns about potential future recessions remain. The digital
      transformation is accelerating, especially in artificial intelligence and cloud computing, which is reshaping
      how businesses operate. The corporate world is increasingly focusing on sustainability, with more companies
      integrating environmental goals into their long-term strategies. The market for electric vehicles has surged, 
      and green technologies are expected to drive the second half of 2024.
    `
  },
  {
    id: 3,
    date: "4/5/24",
    title: "Q1 2024 MICHAEL REPORT",
    image: r3,
    description: "This is the description for the Q1 2024 report.",
    content: `
      The first quarter of 2024 has brought about a mix of uncertainty and optimism in the financial world. Stock
      markets have been volatile, influenced by both positive and negative macroeconomic indicators. Inflation rates
      have started to stabilize, but concerns over the global supply chain crisis remain, particularly in the tech
      industry. The real estate market has cooled off slightly from its pandemic-driven highs, but demand in key
      urban areas continues to be strong. This report examines the performance of various industries, including
      financial services, energy, and healthcare. Notably, the healthcare sector has seen significant growth,
      driven by advancements in biotechnology and pharmaceuticals. The report also delves into the geopolitical
      landscape, with tensions between major powers influencing global trade routes and market sentiments. The
      outlook for the year remains cautious but hopeful, with positive signals in innovation and technological
      advancements.
    `
  },
  {
    id: 4,
    date: "12/10/23",
    title: "Year-End 2023 MICHAEL REPORT",
    image: r4,
    description: "This is the description for the Year-End 2023 report.",
    content: `
      The year-end report for 2023 reflects on the overall performance of global markets, highlighting key
      successes and challenges faced throughout the year. Despite facing a number of global economic challenges,
      such as inflation and political instability, the year closed with optimism in key sectors like tech and
      renewable energy. One of the main takeaways from 2023 is the continued dominance of electric vehicles,
      with substantial investment in EV infrastructure. The renewable energy sector has grown significantly,
      and this year marks a turning point in the global shift towards cleaner energy solutions. Meanwhile, the
      financial markets have experienced ups and downs, influenced by fluctuating interest rates and central
      bank policies. The real estate market saw a slowdown but remains a strong investment option in select
      regions. Looking ahead, the report predicts continued growth in the tech sector, with artificial intelligence
      and machine learning expected to dominate future advancements. It also emphasizes the importance of sustainable
      practices for long-term market success.
    `
  },
  {
    id: 5,
    date: "9/8/23",
    title: "Q3 2023 MICHAEL REPORT",
    image: r5,
    description: "This is the description for the Q3 2023 report.",
    content: `
      The third quarter of 2023 witnessed significant shifts in global financial markets, with volatility reaching
      new heights. Despite the challenges, many markets managed to maintain growth, particularly in technology
      and consumer goods. This report focuses on the major global events that impacted the markets, including
      rising geopolitical tensions, trade disruptions, and shifts in government policies. In addition, the report
      highlights key industries that saw notable growth, such as the tech sector, especially in areas like cybersecurity,
      cloud computing, and artificial intelligence. The renewable energy sector also made strong strides, with
      substantial investments in solar and wind energy projects. This report also covers the latest consumer trends,
      which indicate a shift towards more sustainable and eco-friendly products. As we approach the final quarter
      of the year, the market is expected to remain uncertain, but with potential for growth in the right sectors.
    `
  },
  {
    id: 6,
    date: "6/6/23",
    title: "Mid-Year 2023 MICHAEL REPORT",
    image: r6,
    description: "This is the description for the Mid-Year 2023 report.",
    content: `
      The Mid-Year 2023 report delves into the performance of key sectors across the globe, focusing on the
      trends that have shaped the first half of the year. While the overall economic recovery continues, there are
      signs of slowing in some regions, particularly in Europe and Asia. The technology sector remains strong, driven
      by advancements in AI, machine learning, and cloud technologies. Consumer spending has been solid, but
      inflation remains a concern for many countries, putting pressure on disposable income. The housing market
      has started to cool in some areas, but demand for real estate remains high in major cities worldwide.
      Renewable energy investments continue to rise, with solar and wind power leading the charge. The automotive
      sector has also seen a shift towards electric vehicles, with increasing interest from both consumers and
      governments looking to reduce carbon emissions. This mid-year report highlights these trends and offers
      a forecast for the remainder of 2023.
    `
  },
  {
    id: 7,
    date: "3/3/23",
    title: "Q1 2023 MICHAEL REPORT",
    image: r7,
    description: "This is the description for the Q1 2023 report.",
    content: `
      The first quarter of 2023 set the stage for a year of continued growth in key industries, despite global
      challenges such as inflation, supply chain disruptions, and geopolitical tensions. The tech industry
      remains at the forefront, with advancements in artificial intelligence, cloud computing, and cybersecurity
      continuing to drive innovation. The renewable energy sector has also experienced rapid growth, fueled by
      government incentives and increasing consumer demand for sustainable energy solutions. The report highlights
      the financial performance of major corporations, particularly in tech, energy, and healthcare sectors.
      The global economy is showing signs of stabilization, with GDP growth rates improving in many countries.
      However, there are still concerns about the pace of recovery in certain regions, particularly in emerging markets.
      The report emphasizes the importance of continued investment in technology and sustainability for long-term
      economic success.
    `
  },
  {
    id: 8,
    date: "12/9/22",
    title: "Year-End 2022 MICHAEL REPORT",
    image:r8,
    description: "This is the description for the Year-End 2022 report.",
    content: `
      The year-end report for 2022 reflects on a year of mixed economic performance globally. While some regions
      experienced strong growth, others faced challenges due to inflation, high energy prices, and political
      instability. Despite these obstacles, key sectors such as technology, renewable energy, and healthcare
      managed to show resilience. The tech industry experienced a boom, driven by increased demand for software,
      cybersecurity, and digital infrastructure. The renewable energy sector continued its upward trajectory,
      with significant investments in wind and solar power projects. Healthcare, particularly biotechnology,
      also saw significant growth, driven by the ongoing need for innovation and research. As we look to 2023,
      the report suggests that the global economy will face challenges but remains optimistic, with continued
      investment in technology and sustainable industries paving the way for long-term success.
    `
  },
  {
    id: 9,
    date: "9/7/22",
    title: "Q3 2022 MICHAEL REPORT",
    image: r9,
    description: "This is the description for the Q3 2022 report.",
    content: `
      The third quarter of 2022 was marked by economic turbulence, as inflation remained high, and global
      supply chains continued to face disruptions. Despite these challenges, the technology sector demonstrated
      robust growth, with significant gains in cloud computing, AI, and e-commerce. The report also highlights
      key consumer trends, such as increased spending on digital services and sustainability-focused products.
      The renewable energy market showed positive signs of growth, with solar and wind energy investments
      reaching record levels. In addition, the healthcare industry showed resilience, especially in pharmaceutical
      and biotech sectors. While global trade faced hurdles, the report indicates a potential stabilization
      in the coming quarters as economies begin to adjust to new market conditions. The outlook for the remainder
      of 2022 remains cautiously optimistic, with an emphasis on innovation and sustainability.
    `
  }
];

const ReportDetailsPageComponent = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const report = reports.find((report) => report.id === parseInt(id));

  if (!report) {
    return <p className="text-center text-red-600 font-medium mt-4">Report not found.</p>;
  }

  const currentIndex = reports.findIndex((r) => r.id === parseInt(id));
  const prevReport = reports[currentIndex - 1];
  const nextReport = reports[currentIndex + 1];

  const handlePrevClick = () => {
    if (prevReport) {
      navigate(`/report/${prevReport.id}`);
    }
  };

  const handleNextClick = () => {
    if (nextReport) {
      navigate(`/report/${nextReport.id}`);
    }
  };

  return (
    <ReportDetailsPage>
      <ReportTitle>{report.title}</ReportTitle>
      <ReportDate>{report.date}</ReportDate>
      <ReportImage
        src={report.image}
        alt={report.title}
      />
      <ReportDescription>{report.description}</ReportDescription>
      <ReportContent>
        {report.content.split("\n").map((paragraph, index) => (
          <p key={index} className="mb-4">{paragraph.trim()}</p>
        ))}
      </ReportContent>
      <NavButtons>
        <NavButton
          onClick={handlePrevClick}
          disabled={!prevReport}
        >
          Previous Report
        </NavButton>
        <NavButton
          onClick={handleNextClick}
          disabled={!nextReport}
        >
          Next Report
        </NavButton>
      </NavButtons>
    </ReportDetailsPage>
  );
};

export default ReportDetailsPageComponent;
